import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-64da7d3c")

_pushScopeId("data-v-64da7d3c")
const _hoisted_1 = { class: "btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3x me-5" }, [
  /*#__PURE__*/_createVNode("i", { class: "bi bi-person icon-size" })
], -1)
const _hoisted_3 = { class: "d-block fw-bold text-start" }
const _hoisted_4 = { class: "settings-heading fw-bolder d-block fs-4 mb-2" }
const _hoisted_5 = { class: "fw-bold fs-6" }
const _hoisted_6 = {
  class: "modal fade",
  id: "show_report_for_individual_product",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_7 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_8 = { class: "modal-content" }
const _hoisted_9 = {
  class: "modal-header",
  id: "kt_modal_new_address_header"
}
const _hoisted_10 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_11 = { class: "svg-icon svg-icon-1" }
const _hoisted_12 = { class: "modal-body  px-lg-17" }
const _hoisted_13 = { class: "list-group list-group-flush" }
const _hoisted_14 = { class: "modal-footer flex-center" }
const _hoisted_15 = {
  type: "reset",
  class: "btn btn-white me-3",
  "data-bs-dismiss": "modal"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_InnerLoader, {
      loading: _ctx.loading,
      innerLoading: true
    }, null, 8, ["loading"]),
    _createVNode("a", null, [
      _createVNode("label", _hoisted_1, [
        _hoisted_2,
        _createVNode("span", _hoisted_3, [
          _createVNode("span", _hoisted_4, _toDisplayString(`${_ctx.$t('message.INDIVIDUAL')} ${_ctx.$t('message.PRODUCT')}`), 1),
          _createVNode("span", _hoisted_5, [
            _createVNode(_component_el_input, {
              onKeyup: _withKeys(_ctx.getIndividualProduct, ["enter"]),
              modelValue: _ctx.economic_number,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.economic_number = $event)),
              placeholder: `${_ctx.$t('message.ENTER')} ${_ctx.$t('message.PRODUCT')} ${_ctx.$t('message.ECONOMIC')} ${_ctx.$t('message.NUMBER')}`,
              class: "col-md-12"
            }, null, 8, ["onKeyup", "modelValue", "placeholder"])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode("div", _hoisted_7, [
        _createVNode("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _createVNode("h2", null, _toDisplayString(_ctx.$t('message.REPORT_OF_PRODUCTS')), 1),
            _createVNode("div", _hoisted_10, [
              _createVNode("span", _hoisted_11, [
                _createVNode(_component_inline_svg, {
                  src: require('@/assets/media/icons/duotone/Navigation/Close.svg')
                }, null, 8, ["src"])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_12, [
            _createVNode("ul", _hoisted_13, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.reports, (report, index) => {
                return (_openBlock(), _createBlock("li", {
                  class: "list-group-item",
                  key: index,
                  innerHTML: report
                }, null, 8, ["innerHTML"]))
              }), 128))
            ])
          ]),
          _createVNode("div", _hoisted_14, [
            _createVNode("button", _hoisted_15, _toDisplayString(_ctx.$t('message.CANCEL')), 1)
          ])
        ])
      ])
    ])
  ], 64))
})